import { useMemo } from 'react'
import {
  getSuggestedDonationDateFromProcedureEligibility,
  getEarliestSuggestedDonationDateFromEligibilities,
} from '@/utils'

export const ELIGIBILITY_DATE_HELPER_TEXT =
  "This is the earliest date you're eligible to donate. You can change it."

const startOfLocalDay = date => {
  if (!date) return null
  const x = new Date(date)
  x.setHours(0, 0, 0, 0)
  return x.getTime()
}

const datesMatch = (a, b) => {
  const ta = startOfLocalDay(a)
  const tb = startOfLocalDay(b)
  return ta != null && tb != null && ta === tb
}

export const getEligibilityDateHelperText = ({
  donorId,
  procedureEligibilities,
  procedureTypeId,
  date,
  startDate,
}) => {
  if (!donorId || !procedureEligibilities?.length) return ''
  const suggested = procedureTypeId
    ? getSuggestedDonationDateFromProcedureEligibility(
        procedureEligibilities,
        procedureTypeId
      )
    : getEarliestSuggestedDonationDateFromEligibilities(procedureEligibilities)
  if (!suggested) return ''
  const matches =
    date != null
      ? datesMatch(date, suggested)
      : startDate != null
        ? datesMatch(startDate, suggested)
        : false
  return matches ? ELIGIBILITY_DATE_HELPER_TEXT : ''
}

export const useEligibilityDateHelperText = params =>
  useMemo(
    () => getEligibilityDateHelperText(params),
    [
      params?.donorId,
      params?.procedureEligibilities,
      params?.procedureTypeId,
      params?.date,
      params?.startDate,
    ]
  )
